/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'date-right': {
    width: 22.734,
    height: 16,
    viewBox: '0 0 1455 1024',
    data: '<path pid="0" d="M1263.367 1024H192.717A192.717 192.717 0 011.53 829.754 114.712 114.712 0 01225.6 794.575h961.29L861.109 253.897a137.655 137.655 0 01-12.236-29.06A115.477 115.477 0 01880.992 0a192.717 192.717 0 01187.363 156.774l369.375 611.8a114.712 114.712 0 0116.824 58.885A192.717 192.717 0 011263.367 1024zM230.954 829.754z" _fill="#C6DCEE"/>'
  }
})
